import { Environment } from '@chegg/commerce-utils';
import { SITE_ID_TEST, SITE_ID_PROD } from '../../constants/AppConstants';
export var forterSnippet = function forterSnippet(environment) {
  return environment === Environment.PRODUCTION ? require('../../constants/Forter/ProdSnippet')["default"]() : require('../../constants/Forter/TestSnippet')["default"]();
};
export var getForterSnippetSiteId = function getForterSnippetSiteId(environment) {
  return environment === Environment.PRODUCTION ? SITE_ID_PROD : SITE_ID_TEST;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/external/DropInPayments/helper.js
// module id = 4703
// module chunks = 11